import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20composition%20of%20white%20sneakers%20beige%20hoodie%20leather%20bag%20gold%20watch%20and%20sunglasses%20scattered%20artfully%20on%20textured%20linen%20fabric%20soft%20morning%20sunlight%20casting%20long%20elegant%20shadows%20warm%20neutral%20palette%20cream%20oatmeal%20sand%20tones%20high-end%20editorial%20catalog%20photography&width=1600&height=900&seq=hero-bg-v2-a7k3m&orientation=landscape"
        alt="Vigorbuy Spreadsheet product collage"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-white/75 text-xs md:text-sm uppercase tracking-[0.25em] mb-4 md:mb-6 font-medium">
            Updated Daily &bull; Product Database &bull; Buying Guides
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4 md:mb-6 drop-shadow-sm">
            Vigorbuy Spreadsheet:<br className="hidden md:block" /> The Ultimate Product Database &amp; Buying Guide
          </h1>
          <p className="text-white/80 text-sm md:text-base max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            Discover the latest <strong>Vigorbuy Spreadsheet</strong> updates, compare products, find trusted recommendations, and learn how to buy smarter with our comprehensive resource center.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3 rounded-full bg-white text-foreground-950 text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-white/90 transition-colors text-center"
            >
              Explore Spreadsheet
            </a>
            <Link
              to="/articles/vigorbuy-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors text-center"
            >
              Read Our Guide
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 md:gap-8 mt-8 md:mt-10">
            <div className="flex items-center gap-1.5 text-white/75 text-xs">
              <i className="ri-check-line text-white/85"></i>
              <span>Updated Daily</span>
            </div>
            <div className="flex items-center gap-1.5 text-white/75 text-xs">
              <i className="ri-check-line text-white/85"></i>
              <span>Product Comparisons</span>
            </div>
            <div className="flex items-center gap-1.5 text-white/75 text-xs">
              <i className="ri-check-line text-white/85"></i>
              <span>Beginner Friendly</span>
            </div>
            <div className="flex items-center gap-1.5 text-white/75 text-xs">
              <i className="ri-check-line text-white/85"></i>
              <span>Trusted Resources</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}